import { Route } from '@angular/router';
import { employeeRoutes } from './layout/employee.routes';
import { adminRoutes } from './layout/admin.routes';
import { vendorRoutes } from './layout/vendor.routes';
import {
  authRoutes,
  authGuard,
  adminAuthGuard,
  vendorAuthGuard,
  ADMIN_MAIN_ROUTE,
  AUTH_MAIN_ROUTE,
  AUTH_ROUTES,
  VENDOR_MAIN_ROUTE,
  employeeGuard,
} from '@kuiper/ibusiness-core';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./layout/employee/employee.component').then(
        c => c.EmployeeComponent
      ),
    children: [...employeeRoutes],
    canActivate: [authGuard, employeeGuard],
  },
  {
    path: ADMIN_MAIN_ROUTE,
    loadComponent: () =>
      import('./layout/admin/admin.component').then(c => c.AdminComponent),
    children: [...adminRoutes],
    canActivate: [adminAuthGuard],
  },
  {
    path: AUTH_MAIN_ROUTE,
    loadComponent: () =>
      import('@kuiper/ibusiness-core').then(c => c.AuthComponent),
    children: [...authRoutes],
  },
  {
    path: AUTH_ROUTES.RESET_PASSWORD,
    loadComponent: () =>
      import('@kuiper/ibusiness-core').then(c => c.ResetPasswordComponent),
  },
  {
    path: VENDOR_MAIN_ROUTE,
    loadComponent: () =>
      import('./layout/vendor/vendor.component').then(c => c.VendorComponent),
    children: [...vendorRoutes],
    canActivate: [vendorAuthGuard],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/',
  },
];
